import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {SidenavService} from '@app-layout/sidenav/data-access';
import {GlobalSearchContainerComponent, GlobalSearchUiStore} from '@global-search/feature';
import {TranslateModule} from '@ngx-translate/core';
@Component({
	selector: 'dc-sidenav-search',
	imports: [FormsModule, GlobalSearchContainerComponent, TranslateModule],
	templateUrl: './sidenav-search.component.html',
	styleUrls: ['./sidenav-search.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavSearchComponent {
	protected readonly sidenavService = inject(SidenavService);
	protected readonly globalSearchStore = inject(GlobalSearchUiStore);

	isSidenavCollapsed = computed(() => this.sidenavService.collapsed());

	openGlobalSearch(): void {
		this.globalSearchStore.patchState({isOpen: true});
	}
}
